import type { SVGProps } from "react";
import omit from "@/utils/omit";

const IconPopupClose = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      {...omit(props, ["className"])}
      className="yfm-icon-popup-close"
    >
      <circle cx="8" cy="8" r="8" fill="#5DE5E3" />
      <path
        d="M11.6137 10.9569L5.04368 4.38626C4.86181 4.20501 4.56743 4.20501 4.38618 4.38626C4.20493 4.56751 4.20493 4.86188 4.38618 5.04376L10.9562 11.6138C11.1381 11.795 11.4324 11.795 11.6137 11.6138C11.7949 11.4325 11.7949 11.1381 11.6137 10.9569Z"
        fill="#17215C"
      />
      <path
        d="M11.6137 4.38626C11.4324 4.20501 11.1381 4.20501 10.9562 4.38626L4.38618 10.9569C4.20493 11.1388 4.20493 11.4325 4.38618 11.6138C4.56743 11.795 4.86181 11.795 5.04368 11.6138L11.6137 5.04376C11.7949 4.86188 11.7949 4.56751 11.6137 4.38626Z"
        fill="#17215C"
      />
    </svg>
  );
};

IconPopupClose.displayName = "IconPopupClose";

export default IconPopupClose;
